import {
  setDebug,
  init as initSDK,
  mockTelegramEnv,
  retrieveLaunchParams,
  emitEvent,
  miniApp,
  viewport,
  swipeBehavior,
  backButton,
  initData,
  themeParams,
  ThemeParamsType,
} from '@tma.js/sdk-react';

/**
 * Initializes the application and configures its dependencies.
 */
export function init(options: { debug: boolean; eruda: boolean; mockForMacOS: boolean }): void {
  // Set @tma.js/sdk-react debug mode and initialize it.
  setDebug(options.debug);
  initSDK();

  options.eruda &&
    void import('eruda').then(({ default: eruda }) => {
      eruda.init();
      eruda.position({ x: 10, y: window.innerHeight / 1.5 });
    });

  // Telegram for macOS has a ton of bugs, including cases, when the client doesn't
  // even response to the "web_app_request_theme" method. It also generates an incorrect
  // event for the "web_app_request_safe_area" method.
  if (options.mockForMacOS) {
    let firstThemeSent = false;
    mockTelegramEnv({
      onEvent(event, next) {
        if (event.name === 'web_app_request_theme') {
          let tp: ThemeParamsType = {};
          if (firstThemeSent) {
            tp = themeParams.state();
          } else {
            firstThemeSent = true;
            tp ||= retrieveLaunchParams().tgWebAppThemeParams;
          }
          return emitEvent('theme_changed', { theme_params: tp });
        }

        if (event.name === 'web_app_request_safe_area') {
          return emitEvent('safe_area_changed', {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
          });
        }

        next();
      },
    });
  }

  backButton.isSupported() && backButton.mount();
  initData.restore();
  miniApp.mount.isAvailable() && miniApp.mount();

  if (viewport.mount.isAvailable()) {
    void viewport.mount().then(async () => {
      if (viewport.isFullscreen() && viewport.exitFullscreen.isAvailable()) {
        await viewport.exitFullscreen();
      }
      viewport.bindCssVars();
      viewport.expand.ifAvailable();
    });
  }

  swipeBehavior.mount.ifAvailable();
}
